enum TypeOfUser {
  FIRST_TIME = 'FIRST_TIME',
  REAL_ESTATE = 'REAL_ESTATE',
  INTER_BUYER = 'INTER_BUYER',
  RETIREES = 'RETIREES',
}

type Range = {
  min: string | number | null;
  max: string | number | null;
};

export type PropertyDocument = {
  id: string;
  property_id?: string;
  file_name?: string;
  original_file_name: string;
  file_type: string;
  file_size?: number;
  s3_url: string;
  description: string | null;
  document_category?: string | null;
  internal?: boolean;
  uploaded_by?: string | null;
  uploaded_at?: string;
  created_at?: string;
  updated_at?: string;
  download_url?: string;
};

const MEDIA_CATEGORIES = new Set(['photo', 'floor_plan', 'map']);

const MEDIA_EXTENSIONS = new Set([
  '.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg',
  '.mp4', '.mov', '.avi', '.webm', '.mkv',
]);

export function isMediaDocument(d: PropertyDocument): boolean {
  if (MEDIA_CATEGORIES.has(d.document_category ?? '')) return true;
  if (d.file_type?.startsWith('image/') || d.file_type?.startsWith('video/')) return true;
  const name = (d.original_file_name ?? d.file_name ?? '').toLowerCase();
  const ext = name.slice(name.lastIndexOf('.'));
  return MEDIA_EXTENSIONS.has(ext);
}

export { TypeOfUser };
export type { Range };
